import { render, staticRenderFns } from "./CarouselEditor.vue?vue&type=template&id=b93ca652&scoped=true"
import script from "./CarouselEditor.vue?vue&type=script&lang=js"
export * from "./CarouselEditor.vue?vue&type=script&lang=js"
import style0 from "./CarouselEditor.vue?vue&type=style&index=0&id=b93ca652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93ca652",
  null
  
)

export default component.exports